export const background = ({ theme: { colors } }) => ({
    backgroundColor: colors.background,
    width: '100%',
    minHeight: '100vh',
    overflow: 'hidden',
});
